import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const announcement = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.ANNOUNCEMENT_REQUEST:
      draft.loading = true;
      return draft;
    case ACTIONS.ANNOUNCEMENT_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.ANNOUNCEMENT_ERROR:
      draft.loading = false;
      draft.error = action.error;
      return draft;
    default:
      return draft;
  }
});

export default announcement;
